import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import Navbar from "../Navbar";
import DocumentForm from "./DocumentForm";
import { documentService } from "../../../../services/document.services";
import { downloadDocument } from "../../../../helpers/documentFile";
import DocumentFileIcon from "../../../GlobalComponents/DocumentFileIcon";

const Index = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    // Sub admin can only view and download
    const canManage = user?.data?.user_sub != "sub";

    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [formOpen, setFormOpen] = useState(false);
    const [editDocument, setEditDocument] = useState(null);
    const [deleteDocument, setDeleteDocument] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [deleteError, setDeleteError] = useState("");

    const getList = () => {
        setLoading(true);
        documentService
            .getList()
            .then((res) => {
                setDocuments(res?.data || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error: ", error);
                setLoading(false);
            });
    };

    const openForm = (doc) => {
        setEditDocument(doc || null);
        setFormOpen(true);
    };

    const onSaved = () => {
        setFormOpen(false);
        setEditDocument(null);
        getList();
    };

    const closeDelete = () => {
        if (deleteLoading) return;
        setDeleteDocument(null);
        setDeleteError("");
    };

    const onDelete = () => {
        setDeleteLoading(true);
        documentService
            .delete({ id: deleteDocument._id })
            .then(() => {
                setDeleteLoading(false);
                setDeleteDocument(null);
                getList();
            })
            .catch((error) => {
                setDeleteLoading(false);
                setDeleteError(error?.common || "There is some server error.");
            });
    };

    useEffect(() => {
        if (user && user.data.user_role === "admin") getList();
    }, []);

    if (!user || user.data.user_role !== "admin") {
        return <Redirect to="/" />;
    }

    return (
        <div>
            <Navbar activePage="documents" />
            <div className="container">
                <div className="pt-4 row align-items-center">
                    <div className="col-md-8">
                        <div className="sub-menu">
                            <h1 className="heading">Documents</h1>
                        </div>
                    </div>
                    <div className="col-md-4 text-right">
                        {canManage && (
                            <button className="btn btn-primary" onClick={() => openForm(null)}>
                                Upload Document
                            </button>
                        )}
                    </div>
                </div>
                <div className="table-scroll mt-4">
                    <table className="main-table">
                        <thead>
                            <tr>
                                <th scope="col" style={{ minWidth: "40%" }}>Title</th>
                                <th scope="col">File</th>
                                <th scope="col">Uploaded</th>
                                <th scope="col" className="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc) => (
                                <tr key={doc._id}>
                                    <td>
                                        <strong>{doc.title}</strong>
                                    </td>
                                    <td>{doc.original_name}</td>
                                    <td>
                                        {moment(doc.updatedAt).format("DD/MM/YYYY")}
                                        {doc.uploaded_by && (
                                            <div className="text-muted small">
                                                {doc.uploaded_by.first_name} {doc.uploaded_by.last_name}
                                            </div>
                                        )}
                                    </td>
                                    <td className="text-right text-nowrap">
                                        <DocumentFileIcon doc={doc} />
                                        <button className="btn btn-default btn-sm mr-2" onClick={() => downloadDocument(doc)}>
                                            Download
                                        </button>
                                        {canManage && (
                                            <React.Fragment>
                                                <button className="btn btn-default btn-sm mr-2" onClick={() => openForm(doc)}>
                                                    Edit / Replace
                                                </button>
                                                <button className="btn btn-default btn-sm text-danger" onClick={() => setDeleteDocument(doc)}>
                                                    Delete
                                                </button>
                                            </React.Fragment>
                                        )}
                                    </td>
                                </tr>
                            ))}

                            {documents.length === 0 && (
                                <tr className="text-center">
                                    <td colSpan="4">{loading ? "Loading..." : "No Record Found"}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <DocumentForm
                isOpen={formOpen}
                document={editDocument}
                onClose={() => setFormOpen(false)}
                onSaved={onSaved}
            />

            <Modal size="md" backdrop="static" isOpen={!!deleteDocument} toggle={closeDelete}>
                <ModalHeader toggle={closeDelete}>Delete Document</ModalHeader>
                <ModalBody>
                    <div className="my-2">
                        Please confirm if you want to delete "{deleteDocument?.title}"? Reps will no longer see it.
                    </div>
                    {deleteError && <span className="text-danger">{deleteError}</span>}
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary mr-2" onClick={closeDelete}>
                        Cancel
                    </button>
                    {deleteLoading ? (
                        <button className="btn btn-primary loader-icon" disabled>
                            <Spinner className="img-svg"></Spinner>
                        </button>
                    ) : (
                        <button className="btn btn-primary" onClick={onDelete}>
                            Ok
                        </button>
                    )}
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default Index;
